'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _itemView = require('./itemView.js');

var _itemView2 = _interopRequireDefault(_itemView);

var _commonItemContainer = require('./commonItemContainer.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemContainer = function (_React$Component) {
  (0, _inherits3.default)(ItemContainer, _React$Component);

  function ItemContainer(props, context) {
    (0, _classCallCheck3.default)(this, ItemContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ItemContainer.__proto__ || (0, _getPrototypeOf2.default)(ItemContainer)).call(this, props, context));

    _this.displayName = 'ItemContainer';

    return _this;
  }

  (0, _createClass3.default)(ItemContainer, [{
    key: 'isSmallItem',
    value: function isSmallItem() {
      var maxWidth = 90;
      var maxHeight = 90;

      if (this.props.styleParams.cubeImages && this.props.styleParams.cubeType === 'fit') {
        if (this.props.style.orientation === 'landscape') {
          //wide image
          return this.props.style.width / this.props.style.ratio <= maxHeight;
        } else {
          //tall image
          return this.props.style.height * this.props.style.ratio <= maxWidth;
        }
      } else {
        return this.props.style.width <= maxWidth || this.props.style.height <= maxHeight;
      }
    }
  }, {
    key: 'isNarrow',
    value: function isNarrow() {
      return this.props.style.width < 200;
    }
  }, {
    key: 'isShort',
    value: function isShort() {
      return this.props.style.height < 150;
    }
  }, {
    key: 'render',
    value: function render() {
      this.props.love.showCounter = this.props.styleParams.loveCounter && !this.isSmallItem() && !this.isNarrow();
      return _react2.default.createElement(_itemView2.default, (0, _extends3.default)({
        layout: 'galleryItem',
        className: 'image',
        isSmallItem: this.isSmallItem(),
        isNarrow: this.isNarrow(),
        isShort: this.isShort()
      }, this.props));
    }
  }]);
  return ItemContainer;
}(_react2.default.Component);

exports.default = (0, _commonItemContainer.CommonItemContainer)(ItemContainer);